import React, { useEffect, useState } from "react";
import { apiUsuario } from "../../api/usuario";
import { apiMobbex } from "../../api/mobbex";
import { Segment, Label, Divider } from "semantic-ui-react";
import {
  expira_aaaa,
  expira_mm,
  guardar_cambios,
  numero_de_identificacion,
  numero_de_tarjeta_credito_debito,
  titular_tarjeta,
  guardar_metodo_de_pago,
  metodo_de_pago_registrado_con_exito,
  si,
  no,
  tarjeta_terminada_en,
  cambiar_metodo_de_pago,
  metodo_de_pago,
} from "../../utils/traductor";
import { estiloBotones } from "../../estilos";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import { estiloColores } from "../../estilos";
import { getid, getemail } from "../../utils/variablesLocales";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";

const apiusuario = new apiUsuario();
const apimobbex = new apiMobbex();

const CambiarMetodoDePago = async (
  setIdentificacion,
  setMobbex_TokenTarjetaTerminaEn1,
  setNumeroTarjeta,
  setTitular,
  setExpiraMM,
  setExpiraAAAA,
  setCVV
) => {
  await apiusuario.actualizarMobbex_TokenTarjeta("", "");

  const respuestaUsuario = await apiusuario.obtener(getid());
  setIdentificacion(respuestaUsuario[0].Identificacion);
  setMobbex_TokenTarjetaTerminaEn1(
    respuestaUsuario[0].Mobbex_TokenTarjetaTerminaEn
  );

  setNumeroTarjeta("");
  setTitular("");
  setExpiraMM("");
  setExpiraAAAA("");
  setCVV("");
};

const GuardarCambios = async (
  Identificacion,
  NumeroTarjeta,
  Titular,
  ExpiraMM,
  ExpiraAAAA,
  CVV,
  setIdentificacion,
  setMobbex_TokenTarjetaTerminaEn1,
  setOpen
) => {
  if (Identificacion === "") {
  } else {
    if (NumeroTarjeta === "") {
    } else {
      if (Titular === "") {
      } else {
        if (ExpiraMM === "") {
        } else {
          if (ExpiraAAAA === "") {
          } else {
            if (CVV === "") {
            } else {
              Swal.fire({
                title: guardar_metodo_de_pago,
                text: "",
                // type: "warning",
                showCancelButton: true,
                confirmButtonText: si,
                confirmButtonColor: estiloColores.Azul,
                cancelButtonText: no,
                cancelButtonColor: estiloColores.Gris,
              }).then((result) => {
                if (result.value) {
                  //muestro back-drop
                  setOpen(true);

                  GuardarCambiosAccion(
                    Identificacion,
                    NumeroTarjeta,
                    Titular,
                    ExpiraMM,
                    ExpiraAAAA,
                    CVV,
                    setIdentificacion,
                    setMobbex_TokenTarjetaTerminaEn1,
                    setOpen
                  );
                }
              });
            }
          }
        }
      }
    }
  }
};

const GuardarCambiosAccion = async (
  Identificacion,
  NumeroTarjeta,
  Titular,
  ExpiraMM,
  ExpiraAAAA,
  CVV,
  setIdentificacion,
  setMobbex_TokenTarjetaTerminaEn1,
  setOpen
) => {
  if (
    Identificacion !== "" &&
    NumeroTarjeta !== "" &&
    Titular !== "" &&
    ExpiraMM !== "" &&
    ExpiraAAAA !== "" &&
    CVV !== ""
  ) {
    //1. guardar numero de identificacion en bd
    const respuestaIdentificacion = await apiusuario.actualizarIdentificacion(
      Identificacion
    );

    if (respuestaIdentificacion.status !== 200) {
      //se produjo algun error al guardar los datos
    }

    //guardar CVV en bd
    const respuestaCVV = await apiusuario.actualizarMobbex_CVV(CVV);

    if (respuestaCVV.status !== 200) {
      //se produjo algun error al guardar los datos
    }

    //2. verificar si existe usuario mobbex registrado en bd
    const respuestaUsuarioExiste = await apiusuario.obtener(getid());

    let Mobbex_IdUsuario = respuestaUsuarioExiste[0].Mobbex_IdUsuario;

    if (
      Mobbex_IdUsuario === "undefined" ||
      Mobbex_IdUsuario === undefined ||
      Mobbex_IdUsuario === null ||
      Mobbex_IdUsuario === ""
    ) {
      //3. creo usuario en mobbex
      const respuestaMobbexCrearCliente = await apimobbex.crearCliente(
        getid() + "_" + Titular,
        getemail(),
        Titular,
        Identificacion
      );

      if (respuestaMobbexCrearCliente.result === true) {
        //4. actualizo en bd Mobbex_IdUsuario
        Mobbex_IdUsuario = respuestaMobbexCrearCliente.data.uid;
        await apiusuario.actualizarMobbex_IdUsuario(Mobbex_IdUsuario);
      }
    }

    //5. verificar si existe tarjeta de debito/credito en bd
    let Mobbex_TokenTarjeta = respuestaUsuarioExiste[0].Mobbex_TokenTarjeta;

    if (
      Mobbex_TokenTarjeta === "undefined" ||
      Mobbex_TokenTarjeta === undefined ||
      Mobbex_TokenTarjeta === null ||
      Mobbex_TokenTarjeta === ""
    ) {
      //6. creo tarjeta en mobbex
      const respuestaMobbexCrearTarjeta = await apimobbex.crearTarjeta(
        NumeroTarjeta,
        ExpiraMM,
        ExpiraAAAA,
        Identificacion,
        Titular
      );

      if (respuestaMobbexCrearTarjeta.result === true) {
        //7. actualizo en bd Mobbex_TokenTarjeta
        Mobbex_TokenTarjeta = respuestaMobbexCrearTarjeta.data.token;
        let Mobbex_TokenTarjetaTerminaEn = "";
        if (NumeroTarjeta.length > 4) {
          Mobbex_TokenTarjetaTerminaEn = NumeroTarjeta.substr(
            NumeroTarjeta.length - 4
          );
        }

        await apiusuario.actualizarMobbex_TokenTarjeta(
          Mobbex_TokenTarjeta,
          Mobbex_TokenTarjetaTerminaEn
        );
      }
    }

    //8. agregar relacion en mobbex entre cliente - tarjeta
    const respuestaMobbexCrearRelacion = await apimobbex.crearRelacion(
      Mobbex_IdUsuario,
      Mobbex_TokenTarjeta
    );

    if (respuestaMobbexCrearRelacion.result === true) {
      //9. actualizo en bd Mobbex_sourceId
      const Mobbex_sourceId = respuestaMobbexCrearRelacion.data.sourceUid;
      await apiusuario.actualizarMobbex_sourceId(Mobbex_sourceId);

      //10. guardar relacion en base de datos
      await apiusuario.actualizarMobbex_sourceId(Mobbex_sourceId);
    }

    const respuestaUsuario = await apiusuario.obtener(getid());
    setIdentificacion(respuestaUsuario[0].Identificacion);
    setMobbex_TokenTarjetaTerminaEn1(
      respuestaUsuario[0].Mobbex_TokenTarjetaTerminaEn
    );

    //oculto back-drop
    setOpen(false);

    Swal.fire({
      // type: "success",
      title: metodo_de_pago_registrado_con_exito,
      text: "",
      timer: 1500,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }
};

export function MetodoPago() {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    (async () => {
      try {
        const respuestaUsuario = await apiusuario.obtener(getid());
        setIdentificacion(respuestaUsuario[0].Identificacion);
        setMobbex_TokenTarjetaTerminaEn1(
          respuestaUsuario[0].Mobbex_TokenTarjetaTerminaEn
        );
      } catch (error) {
        console.error(error);
      }
    })();
  });

  const [Identificacion, setIdentificacion] = useState("-1");
  const [NumeroTarjeta, setNumeroTarjeta] = useState("");
  const [Titular, setTitular] = useState("");
  const [ExpiraMM, setExpiraMM] = useState("");
  const [ExpiraAAAA, setExpiraAAAA] = useState("");
  const [CVV, setCVV] = useState("");
  const [Mobbex_TokenTarjetaTerminaEn1, setMobbex_TokenTarjetaTerminaEn1] =
    useState("****");

  return (
    <div>
      <Segment style={{ borderColor: "rgb(229, 246, 253)" }}>
        <Label
          attached="top"
          style={{
            backgroundColor: "rgb(229, 246, 253)",
            color: "rgb(1, 67, 97)",
          }}
        >
          {metodo_de_pago}
        </Label>
        {Identificacion === "" ? (
          <div>
            <input
              id={numero_de_identificacion}
              name={numero_de_identificacion}
              placeholder={numero_de_identificacion}
              value={Identificacion}
              style={{
                borderColor: Identificacion === "" ? "red" : "gainsboro",
              }}
              onChange={(e, data) => {
                setIdentificacion(e.target.value);
              }}
            ></input>
          </div>
        ) : (
          <div></div>
        )}
        {Mobbex_TokenTarjetaTerminaEn1 === "" ? (
          <div>
            <input
              id={numero_de_tarjeta_credito_debito}
              name={numero_de_tarjeta_credito_debito}
              placeholder={numero_de_tarjeta_credito_debito}
              type="number"
              step="1"
              maxLength="16"
              style={{
                marginTop: "5px",
                borderColor: NumeroTarjeta === "" ? "red" : "gainsboro",
              }}
              onChange={(e, data) => {
                if (e.target.value.length > 16) {
                  e.target.value = e.target.value.slice(0, 16);
                }

                setNumeroTarjeta(e.target.value);
              }}
            ></input>
            <input
              id={titular_tarjeta}
              name={titular_tarjeta}
              placeholder={titular_tarjeta}
              style={{
                marginTop: "5px",
                borderColor: Titular === "" ? "red" : "gainsboro",
              }}
              onChange={(e, data) => {
                setTitular(e.target.value);
              }}
            ></input>
            <input
              id={expira_mm}
              name={expira_mm}
              placeholder={expira_mm}
              type="number"
              step="1"
              min="1"
              max="12"
              style={{
                marginTop: "5px",
                borderColor: ExpiraMM === "" ? "red" : "gainsboro",
              }}
              onChange={(e, data) => {
                if (e.target.value.length > 2) {
                  e.target.value = e.target.value.slice(0, 2);
                }

                if (parseInt(e.target.value) < 1) {
                  e.target.value = "";
                }

                if (parseInt(e.target.value) > 12) {
                  e.target.value = "";
                }

                setExpiraMM(e.target.value);
              }}
            ></input>
            <input
              id={expira_aaaa}
              name={expira_aaaa}
              placeholder={expira_aaaa}
              type="number"
              step="1"
              min="1"
              max="99"
              style={{
                marginTop: "5px",
                borderColor: ExpiraAAAA === "" ? "red" : "gainsboro",
              }}
              onChange={(e, data) => {
                if (e.target.value.length > 2) {
                  e.target.value = e.target.value.slice(0, 2);
                }

                setExpiraAAAA(e.target.value);
              }}
            ></input>
            <input
              id="cvv"
              name="cvv"
              placeholder="CVV"
              type="number"
              step="1"
              min="1"
              max="999"
              style={{
                marginTop: "5px",
                borderColor: CVV === "" ? "red" : "gainsboro",
              }}
              onChange={(e, data) => {
                if (e.target.value.length > 3) {
                  e.target.value = e.target.value.slice(0, 3);
                }

                setCVV(e.target.value);
              }}
            ></input>
          </div>
        ) : (
          <div></div>
        )}
        {Identificacion === "" || Mobbex_TokenTarjetaTerminaEn1 === "" ? (
          <div style={{ textAlign: "right" }}>
            <Divider></Divider>
            <Button
              style={estiloBotones.Ingresar}
              variant="contained"
              onClick={() => {
                GuardarCambios(
                  Identificacion,
                  NumeroTarjeta,
                  Titular,
                  ExpiraMM,
                  ExpiraAAAA,
                  CVV,
                  setIdentificacion,
                  setMobbex_TokenTarjetaTerminaEn1,
                  setOpen
                );
              }}
            >
              {guardar_cambios}
            </Button>
          </div>
        ) : (
          <div></div>
        )}
        {Mobbex_TokenTarjetaTerminaEn1 !== "" ? (
          <div style={{ textAlign: "center" }}>
            {tarjeta_terminada_en}
            <div style={{ paddingTop: "10px", textAlign: "center" }}>
              **** **** **** {Mobbex_TokenTarjetaTerminaEn1}
            </div>
            <Divider></Divider>
            <div style={{ textAlign: "right" }}>
              <small>
                <label
                  onClick={() => {
                    CambiarMetodoDePago(
                      setIdentificacion,
                      setMobbex_TokenTarjetaTerminaEn1,
                      setNumeroTarjeta,
                      setTitular,
                      setExpiraMM,
                      setExpiraAAAA,
                      setCVV
                    );
                  }}
                >
                  {cambiar_metodo_de_pago}
                </label>
              </small>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </Segment>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  );
}
